import React, { Component } from "react";
import { withRouter } from "../../hoc/withRouter";
import { config } from "../../config/GeneralConfig";
import { Form, Select } from "antd";

const { Option } = Select;

class SelectTypeBill extends Component {
  render() {
    const { type_bill } = config;
    return (
      <Form.Item label="Tipe Bill" className="col-lg-12">
        <Select style={{ fontSize: "85%" }} placeholder="Select Type Bill" defaultValue={this.props.value} onChange={this.props.onChangeValue}>
          {Object.keys(type_bill).map((s) => {
            return (
              <Option key={s} value={s}>
                {type_bill[s]}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    );
  }
}

export default withRouter(SelectTypeBill);
